export default __webpack_public_path__ + "static/media/YOOZ_AGENT.13b6ce9d.png";